/* src/views/logements/proto/ParcProto.jsx — LA LISTE « Le parc » de la
   destination ⌂ Logements, transcrite de docs/handoff/logements-1-fiche.jsx
   (livré 2026-08-27, refresh 23h58) : le bandeau à trois jauges, les cartes
   de logement triées par avancement (photo, proprio, trois jalons, N/3),
   les deux boutons d'ajout et la note de pied. LE DESSIN, PAS LA LOGIQUE —
   styles copiés tels quels, valeurs en props, gestes en onXxx. Les
   data-testid sont ajoutés (attributs), rien d'autre. */

import React from 'react'

/* ── le bandeau : « Logements » + 3 jauges d'avancement ───────────── */
export function BandeauParc({ sousTitre, jauges }) {
  return (
    <div className="bandeau">
      <p className="bSous">{sousTitre}</p>
      <h2 className="bTitre">Logements</h2>
      <div style={{ display: 'flex', gap: '8px', marginTop: '12px', paddingTop: '11px',
        borderTop: '1px solid rgba(255,255,255,.18)', position: 'relative' }}>
        {jauges.map((j) => (
          <span key={j.lb} style={{ flex: '1', minWidth: '0',
            background: 'rgba(255,255,255,.13)', borderRadius: '11px', padding: '9px 10px' }}
            data-testid={`parc-jauge-${j.id}`}>
            <span style={{ display: 'flex', alignItems: 'baseline', gap: '3px' }}>
              <b style={{ fontSize: '19px', color: '#fff', fontWeight: '600',
                lineHeight: '1' }}>{j.n}</b>
              <span style={{ fontSize: '11px',
                color: 'rgba(255,255,255,.5)' }}>/ {j.total}</span>
            </span>
            <span style={{ display: 'block', fontSize: '9.5px', color: 'rgba(255,255,255,.72)',
              margin: '3px 0 5px', overflow: 'hidden', textOverflow: 'ellipsis',
              whiteSpace: 'nowrap' }}>{j.lb}</span>
            <span style={{ display: 'block', height: '3px', borderRadius: '2px',
              background: 'rgba(255,255,255,.2)', overflow: 'hidden' }}>
              <span style={{ display: 'block',
                width: `${j.total ? Math.round((j.n / j.total) * 100) : 0}%`,
                height: '100%', borderRadius: '2px', background: '#87b8e6' }} />
            </span>
          </span>
        ))}
      </div>
    </div>
  )
}

/* ── une carte de logement (photo · nom · proprio · jalons · N/3) ──── */
const CHIP_ON = { background: 'var(--vert-bg)', color: 'var(--vert-tx)' }
const CHIP_OFF = { background: '#f4f6f8', color: '#b6bfc7' }
const DOT_ON = '#2f9e6e'
const DOT_OFF = '#dde4ea'

function couleurAvancement(n) {
  if (n >= 3) return '#2f9e6e'
  if (n >= 1) return '#87b8e6'
  return '#c3cdd6'
}
function libelleAvancement(n) {
  if (n >= 3) return 'prêt'
  if (n >= 1) return 'en cours'
  return 'à faire'
}

export function CarteLogement({ id, nom, proprio, photoUrl, jalons, onOuvrir }) {
  const chips = [
    { lb: 'Beds24', on: !!jalons.beds24 },
    { lb: 'Direct', on: !!jalons.direct },
    { lb: 'Checklist', on: !!jalons.checklist },
  ]
  const n = chips.filter((ch) => ch.on).length
  const couleur = couleurAvancement(n)
  return (
    <button onClick={onOuvrir} data-testid={`parc-log-${id}`}
      style={{ display: 'flex', alignItems: 'stretch', gap: '0', width: '100%',
        textAlign: 'left', background: '#fff', border: 'none', borderRadius: '14px',
        overflow: 'hidden', marginBottom: '9px', cursor: 'pointer',
        boxShadow: '0 1px 3px rgba(35,50,64,.09),0 0 0 1px rgba(35,50,64,.05)',
        minHeight: '82px' }}>
      {photoUrl ? (
        <span style={{ flex: '0 0 82px', background: '#e6eaee', display: 'flex',
          flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          gap: '3px', position: 'relative', overflow: 'hidden' }}>
          <span style={{ position: 'absolute', inset: '0',
            background: 'linear-gradient(135deg,#c3d5e4,#87b8e6)' }} />
          <img src={photoUrl} alt="" loading="lazy"
            style={{ position: 'absolute', inset: '0', width: '100%', height: '100%',
              objectFit: 'cover' }} />
          <span style={{ position: 'relative', fontSize: '8.5px',
            color: 'rgba(255,255,255,.85)', textShadow: '0 1px 2px rgba(35,50,64,.55)',
            marginTop: 'auto', marginBottom: '5px' }}>{id}</span>
        </span>
      ) : (
        <span style={{ flex: '0 0 82px', background: '#e6eaee', display: 'flex',
          flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          gap: '3px', position: 'relative', overflow: 'hidden' }}>
          <span style={{ position: 'relative', fontSize: '19px', color: '#b6bfc7' }}>◫</span>
          <span style={{ position: 'relative', fontSize: '8.5px',
            color: '#b6bfc7' }}>sans photo</span>
        </span>
      )}
      <span style={{ flex: '1', minWidth: '0', padding: '10px 12px', display: 'flex',
        flexDirection: 'column', justifyContent: 'center', gap: '6px' }}>
        <span style={{ display: 'block', fontSize: '13px', fontWeight: '600',
          color: 'var(--navy-d)', lineHeight: '1.25', overflow: 'hidden',
          textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nom}</span>
        <span style={{ display: 'block', fontSize: '10px', color: 'var(--gris)',
          overflow: 'hidden', textOverflow: 'ellipsis',
          whiteSpace: 'nowrap' }}>{proprio}</span>
        <span style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
          {chips.map((ch) => (
            <span key={ch.lb} style={{ display: 'inline-flex', alignItems: 'center',
              gap: '4px', padding: '1px 7px 1px 5px', borderRadius: '7px',
              fontSize: '9px', ...(ch.on ? CHIP_ON : CHIP_OFF) }}>
              <span style={{ width: '5px', height: '5px', borderRadius: '50%',
                background: ch.on ? DOT_ON : DOT_OFF }} />{ch.lb}</span>
          ))}
        </span>
      </span>
      <span style={{ flex: '0 0 62px', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: '5px', padding: '0 8px',
        borderLeft: '1px solid var(--bord)' }}>
        <span style={{ fontSize: '15px', fontWeight: '600', color: couleur,
          lineHeight: '1' }}>{n}<span style={{ fontSize: '10px', color: 'var(--gris-d)',
          fontWeight: '400' }}>/3</span>
        </span>
        <span style={{ display: 'block', width: '100%', height: '3px',
          borderRadius: '2px', background: '#eef2f6', overflow: 'hidden' }}>
          <span style={{ display: 'block', width: `${Math.round((n / 3) * 100)}%`,
            height: '100%', borderRadius: '2px', background: couleur }} />
        </span>
        <span style={{ fontSize: '8.5px', color: 'var(--gris-d)', textAlign: 'center',
          lineHeight: '1.2' }}>{libelleAvancement(n)}</span>
      </span>
    </button>
  )
}

/* ── les deux boutons d'ajout + la note de pied ───────────────────── */
export function ActionsParc({ onAddProprio, onAddLogement, onAddSousLoc, sousLocPossible, note }) {
  return (
    <>
      <div className="act">
        <button className="bt bt-s" data-testid="parc-add-proprio"
          onClick={onAddProprio}>＋ Propriétaire</button>
        <button className="bt bt-s" data-testid="parc-add-logement"
          onClick={onAddLogement}>＋ Logement</button>
        {/* Conservé de l'existant (inventaire lot 4 §3 Liste) : le raccourci
            sous-location n'apparaît que si le groupe p6 existe. */}
        {sousLocPossible && (
          <button className="bt bt-s" data-testid="parc-add-sousloc"
            onClick={onAddSousLoc}>＋ Sous-location</button>
        )}
      </div>
      <p className="note">{note}</p>
    </>
  )
}
